<h1 mat-dialog-title>Wait!</h1>
<div mat-dialog-content>
  <p>Are you sure you want to delete this? This cannot be undone.</p>
</div>
<div mat-dialog-actions class="button-group">
  <div class="spacer"></div>
  <button mat-button (click)="closeModal(false)">Cancel</button>
  <button mat-flat-button color="primary"  (click)="closeModal(true)">Delete</button>
</div>
